<template>
    <div class="index">
        <!-- appbar -->
        <div style="background-color:#da5b3a;height:100px;border-top-left-radius:5px;border-top-right-radius:5px;">
            <div style="float:left;margin-top:32px;margin-left:20px;">
                <mu-menu cover>
                    <mu-icon size="36" value="account_circle" color="white" @click="openAccountInfo"></mu-icon>
                </mu-menu>
            </div>
            <div style="float:left;margin-top:32px;margin-left:10px;color:#263238;font-size:12px;">
                Hello <span>{{tableOrderInfo.Name}}</span><br />
                Weclone to {{seller.RestaurantName}}<br />
                Order press Restaurant & All you can eat
            </div>
            <!--<div style="position:absolute;top:10px;right:10px;" v-if="showFullScreen">
            <mu-icon size="24" value="fullscreen" color="white" @click="handleFullScreen" v-if="!$store.state.isFullscreen"></mu-icon>
            <mu-icon size="24" value="fullscreen_exit" color="white" @click="handleFullScreen" v-if="$store.state.isFullscreen"></mu-icon>
        </div>-->

        </div>
        <!-- index content -->
        <div>
            <label for="avatar">
                <img :src="getImgUrl(seller.BackImage,400)" alt="Restaurant background map" style="width:100%;height:210px;">
            </label>
            <div class="backimage-logo">
                <img src="../assets/logo.png" />
            </div>
        </div>
        <div style="margin-top:15px;text-align:center;width:100%;position : absolute;">
            <!--<div>
            <mu-button large color="red" class="nav-btn" @click="jumpRestaurant()">
                <mu-avatar style="margin-left:-20px;" size="48">
                    <img src="../assets/image/restaurant.png">
                </mu-avatar>
                <div class="nav-header-title">
                    <div class="nav-title">Menuer</div>
                    <div class="nav-sub-title">ikke "all you can eat"</div>
                </div>
                <div class="nav-header-icon">
                    <mu-icon size="26" value="play_arrow" color="white"></mu-icon>
                </div>
            </mu-button>
        </div>-->
            <mu-button flat color="#da5b3a">
                <img src="../assets/image/table_48.png" width="22" height="22" />
                &nbsp;<span style="font-size:18px;font-weight:600;">{{this.tableOrderInfo.TableName}}</span>
            </mu-button>
            <div style="margin-top:15px">
                <mu-button large color="red" class="nav-btn" @click="jumpBufft()">
                    <mu-avatar style="margin-left:-20px;" size="48">
                        <img src="../assets/image/allyoucaneat.png">
                    </mu-avatar>
                    <div class="nav-header-title">
                        <div class="nav-title">All you can eat</div>
                        <div class="nav-sub-title">Spis så meget du kan</div>
                    </div>
                    <div class="nav-header-icon">
                        <mu-icon size="26" value="play_arrow" color="white"></mu-icon>
                    </div>
                </mu-button>
            </div>

            <div style="margin-top:15px; font-size:16px;font-weight:600;">
                <a @click="jumTakeaway()" style="color: #da5b3a;">Takeaway</a>
            </div>
            <mu-button large fab color="orange" class="btn-my notranslate" @click="openBill" style="background-color:#da5b3a">
                <div>
                    <div>
                        <mu-icon value="assignment"></mu-icon>
                    </div>
                    <div>
                        Bill
                    </div>
                </div>
            </mu-button>

            <mu-button large fab color="orange" class="btn-service notranslate" @click="callService" style="background-color:#da5b3a">
                <div>
                    <div>
                        <mu-icon value="contact_phone"></mu-icon>
                    </div>
                    <div>
                        Service
                    </div>
                </div>
            </mu-button>
        </div>

        <div class="ol-map" id="container" style="width:100%;height:100%;display:none;"></div>
        <mu-bottom-sheet :open.sync="open">
            <mu-list @item-click="closeAccountInfo" class="notranslate">
                <mu-sub-header>Select One</mu-sub-header>
                <mu-list-item button @click="menuCartLink">
                    <mu-list-item-action>
                        <mu-icon value="shopping_cart" color="orange"></mu-icon>
                    </mu-list-item-action>
                    <mu-list-item-title>Cart list</mu-list-item-title>
                </mu-list-item>
                <mu-list-item button @click="menuOrderLink">
                    <mu-list-item-action>
                        <mu-icon value="assignment" color="orange"></mu-icon>
                    </mu-list-item-action>
                    <mu-list-item-title>Bill list</mu-list-item-title>
                </mu-list-item>
                <mu-list-item button @click="exitApp">
                    <mu-list-item-action>
                        <mu-icon value="reply" color="orange"></mu-icon>
                    </mu-list-item-action>
                    <mu-list-item-title>Exit</mu-list-item-title>
                </mu-list-item>
            </mu-list>
        </mu-bottom-sheet>

        <mu-bottom-sheet :open.sync="billOpen" style="height:100%;">
            <mu-list @item-click="closeBill" style="overflow-y: scroll;height:100%;">
                <!--<mu-sub-header style="height:24px;line-height:24px;">Bill list</mu-sub-header>-->
                <div class="ower" v-show="!showOrderTip">
                    <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">All</span>
                    <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" v-for="(val, key, index) in cartOwerData" :key="index">{{key.replace(/\"/g,"")}}</span>
                </div>
                <div class="cart-box" style="margin-top:5px;padding-left:5px;padding-right:5px;" v-for="(val, key, index) in cartShowData" :key="index" v-show="!showOrderTip">
                    <mu-list>
                        <mu-list-item style="height:36px;">
                            <mu-list-item-content>
                                <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                            </mu-list-item-content>
                        </mu-list-item>
                        <mu-divider shallow-inset></mu-divider>
                        <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                            <mu-flex>
                                <mu-avatar style="width: 60px !important;">
                                    <img :src="getImgUrl(item.foodImage,400)" style="border-radius:0;">
                                </mu-avatar>
                            </mu-flex>
                            <mu-list-item-content>
                                <div style="margin-left: 5px;">
                                    <div style="float:left;">
                                        <div style="font-size:12px;height:24px;line-height:24px;">
                                            {{item.foodName}}
                                        </div>
                                        <div>
                                            <span class="now">{{ item.price }} kr</span>
                                            <span>x {{ item.quantity }}</span>
                                        </div>
                                    </div>
                                    <div class="cart-opration" style="float:right;color:#e53935;">
                                        <span class="now"> {{item.quantity * item.price}} kr</span>
                                    </div>
                                </div>
                            </mu-list-item-content>
                        </mu-list-item>
                    </mu-list>
                </div>
                <mu-list v-show="!showOrderTip">
                    <mu-list-item style="height:45px;margin:5px auto;padding-right:5px;">

                        <mu-list-item-content>

                            <div style="float:right;font-size:16px;font-weight:600;">Total: <span class="now" style="font-size:16px;color:#e53935;">{{total}} kr</span></div>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
                <div v-show="!showOrderTip">
                    <mu-expansion-panel v-for="(value, k, i) in cartBuffetShowData" :key="i" style="width:100%;" :expand="getExpand(i)" :zDepth="0">
                        <div slot="header" style="width:100%;">{{getOrderTimes(k)}} </div>
                        <div class="cart-box" style="margin-top:5px;" v-for="(val, key, index) in getTypeGroup(value)" :key="index">
                            <mu-list>
                                <mu-list-item style="height:36px;">
                                    <mu-list-item-content>
                                        <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                                    </mu-list-item-content>
                                </mu-list-item>
                                <mu-divider shallow-inset></mu-divider>
                                <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                                    <mu-flex>
                                        <mu-avatar style="width: 60px !important;">
                                            <img :src="getImgUrl(item.foodImage,400)" style="border-radius:0;">
                                        </mu-avatar>
                                    </mu-flex>
                                    <mu-list-item-content>
                                        <div style="margin-left: 5px;">
                                            <div style="float:left;">
                                                <div style="font-size:12px;height:24px;line-height:24px;">
                                                    {{item.foodName}}
                                                </div>
                                            </div>
                                            <div class="cart-opration" style="float:right;">
                                                <span class="now">x {{item.quantity}} </span>
                                            </div>
                                        </div>
                                    </mu-list-item-content>
                                </mu-list-item>
                            </mu-list>
                        </div>
                    </mu-expansion-panel>

                </div>
                <mu-list>
                    <mu-list-item style="height:60px;margin:5px auto;">
                        <mu-list-item-content>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
                <mu-button large fab color="green" class="btn-home notranslate" @click="closeBill">
                    <div>
                        <div>
                            <mu-icon value="reply"></mu-icon>
                        </div>
                        <div>
                            Back
                        </div>
                    </div>
                </mu-button>


                <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
                    <mu-flex class="flex-wrapper" justify-content="center">
                        <div style="font-size:16px;font-weight:600;color:#DA5B3A;">You have not submitted your order, please choose the dishes to order!</div>
                    </mu-flex>
                    <mu-flex class="flex-wrapper" justify-content="center">
                        <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" @click="jumpBufft" style="text-transform:unset;">Start Order</mu-button></div>
                    </mu-flex>
                </div>

            </mu-list>
        </mu-bottom-sheet>
        <br />
        <br />
    </div>
</template>
<script>
    import { globalData } from '../utils/global'
    export default {
        name: 'Index',
        data() {
            return {
                showFullScreen: true,
                seller: {},
                order: {},
                tableOrderInfo: {},
                open: false,
                billOpen: false,
                cartList: [],
                groupCartBuffetList: [],
                groupCartList: [],
                showOrderTip: false,
                cartShowData: [],
                cartBuffetShowData: {},
                total: 0,
                current: -1,
                cartOwerData: {},
            }
        },
        components: {
          
        },
        mounted() {
            this.initDate();
            this.getRestaurantInfo();
        },
        created() {
            this.dataRefreh();
        },
        destroyed() {
            this.clear();
        },
        methods: {
            initDate() {
                if (this.$route.path == '/index') {
                    if ("undefined" != typeof api) {
                        this.showFullScreen = false;
                    }
                    this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                    if (this.tableOrderInfo.TableName == undefined || this.tableOrderInfo.TableName == null) {
                        this.$router.push({
                            path: '/error',
                            query: {}
                        })
                    }
                    if (this.tableOrderInfo.Name == undefined || this.tableOrderInfo.Name == null) {
                        this.$router.push({
                            path: '/',
                            query: {}
                        })
                    }
                    this.getOrderList();
                }
            },
            getNoticeOrderMessage() {
                if (this.order.OrderId == undefined || this.order.OrderId == null) {
                    return;
                }
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.TableName,
                    orderId: this.order.OrderId
                };
                this.$get('QRCodeOrder/GetNoticeOrderServiceMessage', param)
                    .then(result => {
                        if (result.code==200) {
                            if (result.data != null) {
                                if (sessionStorage.getItem("message") == undefined || sessionStorage.getItem("message") == null || sessionStorage.getItem("message") != result.data.Message) {
                                    sessionStorage.setItem("message", result.data.Message);
                                    this.$alert(result.data.Message, 'Message prompt', { okLabel: "I got it" }).then(() => {
                                        this.$post('QRCodeOrder/UpdateOrderServiceMessageNotice', { Id: result.data.Id })
                                            .then(response1 => {
                                            });
                                    });
                                }
                            }
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getRestaurantInfo() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeBasicInfo/GetRestaurant', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.seller = response.data;
                            window.localStorage.setItem('seller', JSON.stringify(this.seller)) 
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            dataRefreh() {
                if (this.intervalId != null) {
                    return;
                }
                this.intervalId = setInterval(() => {
                    this.getOrderList();
                    this.getNoticeOrderMessage();
                }, 15000);
            },
            getOrderTimes(times) {
                let txt = '';
                if (times == 1) {
                    txt = 'First time order';
                }
               else if (times == 2) {
                    txt = 'The second  order';
                }
                else if (times == 3) {
                    txt = 'The third order';
                }
                else if (times == 4) {
                    txt = 'The fourth order';
                }
                else {
                    txt = 'The ' + times + 'th order';
                }
                return txt;
            },
            clear() {
                clearInterval(this.intervalId);
                this.intervalId = null;
            },
            timeOutCheck() {
                let that = this;
                var time = window.localStorage.getItem('timeOut');
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >=120) {
                        this.$alert('The page is invalid. Please scan the QR code again!', 'Alert', {
                            type: 'warning', okLabel: 'Sure',
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert('The page is invalid. Please scan the QR code again!', 'Alert', {
                    type: 'warning', okLabel: 'Sure',
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;

            },
            jumpRestaurant() {
                if (!this.timeOutCheck()) {
                    return;
                }
                this.billOpen = false;
                if (this.tableOrderInfo.Voksne == 0) {
                    this.$router.push({
                        path: '/dinersNum', query: {
                            isSeft: 0
                        }
                    })
                }
                else {
                    this.$router.push({
                        path: '/restaurant', query: {
                            isSeft: 0
                        }
                    })
                }
            },
            jumpBufft() {
                if (!this.timeOutCheck()) {
                    return;
                }
                this.billOpen = false;
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.TableName
                };
                this.$get('QRCodeOrder/CheckIsBuffetPackage', param)
                    .then(response => {
                        if (response.code ==200) {
                            if (response.data) {
                                this.$router.push({
                                    path: '/buffet', query: {
                                        isSeft: 1
                                    }
                                })
                            }
                            else {
                                this.$router.push({
                                    path: '/buffetSelect',query: {
                                    }
                                })
                            }
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
             
            },
            closeAccountInfo() {
                this.open = false;
            },
            openAccountInfo() {
                this.open = true;
            },
            closeBill() {
                this.billOpen = false;
            },
            openBill() {
                this.billOpen = true;
            },
            callService() {
                this.$confirm('Do you need to call human service?', 'Confirm', {
                    type: 'message',
                    okLabel: 'Ok',
                    cancelLabel: 'Cancel'
                }).then(({ result }) => {
                    if (result) {
                        let param = {
                            restaurantId: this.tableOrderInfo.restaurantId,
                            OrderId: this.order.OrderId == undefined ? null : this.order.OrderId,
                            OrderNo: this.order.OrderNo == undefined ? null : this.order.OrderNo,
                            TableName: this.tableOrderInfo.TableName,
                        };
                        this.$post('QRCodeOrder/CallOrderService', param)
                            .then(response => {
                                if (response.code == 200) {
                                    this.$toast.success(response.data);
                                } else {
                                    this.$toast.info(response.data);
                                }
                            });
                    }
                })
                    
            },
            getOrderList() {
                this.total = 0;
                let param = {
                    tableName: this.tableOrderInfo.TableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response != null && response != '' && response.code == 2) {
                            var data = response.data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.order = data;
                            var orderTimeArr = data.OrderTimeStr.split('-');
                            this.tableOrderInfo.OrderTime = orderTimeArr[0];
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.OrderId })
                                .then(result => {
                                    if (result != null && result != '' && result.code == 2) {
                                        this.cartList = result.data;
                                        if (this.cartList.length == 0) {
                                            this.cartShowData = [];
                                            this.showOrderTip = true;
                                            return;
                                        }
                                        this.total = 0;
                                        this.showOrderTip = false;
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            this.total += (this.cartList[i].quantity * this.cartList[i].price);
                                        }

                                        this.cartOwerData = this.groupBy(this.cartList, (cart) => {
                                            return cart.createUser
                                        });

                                        //汇总所有人数量
                                        var map = {},
                                            dest = [];
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            var ai = this.cartList[i];
                                            var isHas = false;
                                                for (var j = 0; j < dest.length; j++) {
                                                    var dj = dest[j];
                                                    if (dj.foodId == ai.foodId && dj.batch == ai.batch) {
                                                        isHas = true;
                                                        dest.splice(j, 1);
                                                        dest.push({
                                                            OrderId: ai.orderId,
                                                            FoodId: ai.foodId,
                                                            FoodName: ai.foodName,
                                                            Price: ai.price,
                                                            FoodDiscount: ai.foodDiscount,
                                                            FoodImage: ai.foodImage,
                                                            FoodImageNail: ai.foodImageNail,
                                                            FoodTypeName: ai.foodTypeName,
                                                            Quantity: ai.quantity + dj.quantity,
                                                            IsSeft: ai.isSeft,
                                                            Batch: ai.batch
                                                        });
                                                        break;
                                                }
                                            }
                                            if (!isHas) {
                                                dest.push({
                                                    OrderId: ai.orderId,
                                                    FoodId: ai.foodId,
                                                    FoodName: ai.foodName,
                                                    Price: ai.price,
                                                    FoodDiscount: ai.foodDiscount,
                                                    FoodImage: ai.foodImage,
                                                    FoodImageNail: ai.foodImageNail,
                                                    FoodTypeName: ai.foodTypeName,
                                                    Quantity: ai.quantity,
                                                    IsSeft: ai.isSeft,
                                                    Batch: ai.batch
                                                });
                                            }

                                        }
                                        this.groupCartList = [];
                                        this.groupCartBuffetList = [];
                                        for (var q = 0; q < dest.length; q++) {
                                            if (dest[q].IsSeft == 0) {
                                                this.groupCartList.push(dest[q]);
                                            }
                                            else {
                                                this.groupCartBuffetList.push(dest[q]);
                                            }
                                        }
                                        this.cartShowData = this.groupBy(this.groupCartList, (cart) => {
                                            return cart.FoodTypeName
                                        });

                                        this.cartBuffetShowData = this.groupBy(this.groupCartBuffetList, (cart) => {
                                            return cart.batch
                                        });

                                    }
                                    else {
                                        this.showOrderTip = true;
                                        this.cartShowData = [];
                                    }
                                });
                        }
                    });
            },
            selectOwerCartlist(index, list) {
                this.current = index;
                let groupCartList = [];
                let groupCartBuffetList = [];
                if (list != null) {
                    for (var q = 0; q < list.length; q++) {
                        if (list[q].IsSeft == 0) {
                            groupCartList.push(list[q]);
                        }
                        else {
                            groupCartBuffetList.push(list[q]);
                        }
                    }
                }
                else {
                    groupCartList = this.groupCartList;
                    groupCartBuffetList = this.groupCartBuffetList;
                }
                if (groupCartList.length > 0) {
                    var total = 0;
                    groupCartList.forEach(function (item) {
                        total += Math.round(item.quantity * (item.FoodDiscount * item.price));
                    });
                    this.total = total;

                    this.cartShowData = this.groupBy(groupCartList, (cart) => {
                        return cart.FoodTypeName
                    });
                }
                else {
                    this.cartShowData = [];
                }

                if (groupCartBuffetList.length > 0) {
                    this.cartBuffetShowData = this.groupBy(groupCartBuffetList, (cart) => {
                        return cart.batch
                    });
                }
                else {
                    this.cartBuffetShowData = [];
                }
            },
            getTypeGroup(val) {
                return this.groupBy(val, (cart) => {
                    return cart.FoodTypeName
                });
            },
            getExpand(index) {
                var count = 0;
                for (var i in this.cartBuffetShowData) {
                    count++;
                }
                if ((index + 1) == count) {
                    return true;
                }
                return false;
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            jumTakeaway() {
                let href = '';
                if (this.seller.Platform == 1) {
                     href = "http://www.luckysushi.dk";
                }
                if (this.seller.Platform == 2) {
                    href = "http://www.luckystar.dk";
                }
                window.open(href, '_blank');
            },
            menuCartLink(){
                this.$router.push({
                    path: '/cartList', query: {
                        isSeft: 0,
                        packageType:0
                    }
                })
            },
            menuOrderLink() {
                this.$router.push({
                    path: '/orderList',query: {
                        isSeft: 0
                    }
                })
            },
            exitApp() {
                if ("undefined" == typeof api) {
                    var userAgent = navigator.userAgent;
                    if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
                        window.open('', '_self').close();
                    } else {
                        window.opener = null;
                        window.open("about:blank", "_self");
                        window.close();
                    }
                }
                else {
                    api.closeWin();
                }
            },
            getDistance($lat1, $lng1, $lat2, $lng2, $len_type = 1, $decimal = 2) {
                $radLat1 = $lat1 * 3.1415926 / 180.0;
                $radLat2 = $lat2 * 3.1415926 / 180.0;
                $a = $radLat1 - $radLat2;
                $b = ($lng1 * 3.1415926 / 180.0) - ($lng2 * 3.1415926 / 180.0);
                $s = 2 * asin(sqrt(pow(sin($a / 2), 2) + cos($radLat1) * cos($radLat2) * pow(sin($b / 2), 2)));
                $s = $s * 6378.137;
                $s = round($s * 1000);
                if ($len_type > 1) {
                    $s /= 1000;
                }
                return round($s, $decimal);
            },
            getLocation() {
                var options = {
                    enableHighAccuracy: true,
                    maximumAge: 1000,
                    timeout: 5000,
                }
                if (navigator.geolocation) {
                    console.log('支持')
                    //浏览器支持geolocation
                    navigator.geolocation.getCurrentPosition(this.onSuccess, this.onError, options);
                } else {
                    //浏览器不支持geolocation
                    console.log('不支持')
                }
            },
            onSuccess(position) {
                //经度
                longitude = position.coords.longitude;

                //纬度
                latitude = position.coords.latitude;

                alert(longitude);
                alert(latitude);
                alert(this.getDistance(119.985977,30.142124, longitude, latitude));
            },
            nError(error) {
                switch (error.code) {
                    case 1:
                        alert("位置服务被拒绝");
                        break;

                    case 2:
                        alert("暂时获取不到位置信息");
                        break;

                    case 3:
                        alert("获取信息超时");
                        break;

                    case 4:
                        alert("未知错误");
                        break;
                }
            }
        },
        watch: {
            '$route': 'initDate'
        },
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .index {
        background-color: #fff;
        border-radius: 5px;
        height: 100%;
        position:absolute;
    }

    .backimage-logo {
        position: absolute;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        width: 100%;
        margin-top: -120px;
    }

        .backimage-logo img {
            height: 96px;
            width: 128px;
        }

    .nav-btn {
        background-color: #da5b3a !important;
        height: 60px;
        border-radius: 10px;
        padding: 0px;
        text-transform: unset;
        width:260px;
    }

    .nav-header-title {
        margin-left: 15px;
    }

        .nav-header-title .nav-title {
            line-height: 20px;
            font-size: 15px;
            font-weight: 600;
            text-align: left;
        }

        .nav-header-title .nav-sub-title {
            line-height: 20px;
            font-size: 12px;
            text-align: left;
        }
       .nav-header-icon {
            line-height: 80px;
            margin: auto;
            vertical-align: middle;
            margin-right:-20px;
        }

    .btn-my {
        position: fixed;
        bottom: 10px;
        left: 10px;
        text-transform: unset;
    }

    .btn-service {
        position: fixed;
        bottom: 10px;
        right: 10px;
        text-transform: unset;
    }
    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }
    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 16px;
        color: #4fc3f7;
    }
    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }
    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .btn-home {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #da5b3a !important;
        text-transform:unset;
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue